import React, { useEffect, useState } from "react";
import API from "../utils/axiosInstance";

const AdminSubscriptionPost = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [subscriptionId, setSubscriptionId] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [type, setType] = useState("text");
  const [attachmentUrl, setAttachmentUrl] = useState("");

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await API.get("/subscriptions/all");
        setSubscriptions(res.data || []);
        if (res.data?.[0]) setSubscriptionId(res.data[0].id);
      } catch (err) {
        console.error("Failed to fetch subscriptions", err);
      }
    };
    fetch();
  }, []);

  const submit = async () => {
    try {
      await API.post("/subscriptions/posts", { subscriptionId, title, content, type, attachmentUrl });
      alert("Post created");
      setTitle("");
      setContent("");
      setAttachmentUrl("");
    } catch (err) {
      console.error(err);
      alert("Failed to create post");
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h3>Admin: Create Subscription Post</h3>
      <div>
        <label>Subscription</label>
        <select value={subscriptionId} onChange={(e) => setSubscriptionId(e.target.value)}>
          {subscriptions.map((s) => (
            <option key={s.id} value={s.id}>{s.title}</option>
          ))}
        </select>
      </div>
      <div>
        <label>Title</label>
        <input value={title} onChange={(e) => setTitle(e.target.value)} />
      </div>
      <div>
        <label>Content (HTML allowed)</label>
        <textarea value={content} onChange={(e) => setContent(e.target.value)} />
      </div>
      <div>
        <label>Type</label>
        <select value={type} onChange={(e) => setType(e.target.value)}>
          <option value="text">Text</option>
          <option value="url">URL</option>
          <option value="file">File</option>
          <option value="video">Video</option>
        </select>
      </div>
      <div>
        <label>Attachment URL</label>
        <input value={attachmentUrl} onChange={(e) => setAttachmentUrl(e.target.value)} />
      </div>
      <div style={{ marginTop: 12 }}>
        <button onClick={submit}>Create Post</button>
      </div>
    </div>
  );
};

export default AdminSubscriptionPost;
